'use strict';
// @flow

import $ from 'jquery';

function GalleryDialogController($scope, $mdDialog, BackgroundImages) {
  'ngInject';

  $scope.isDialogLoading = true;
  $scope.backgroundImages = { categories: [] };
  $scope.currentBackgroundImages = [];
  $scope.selectedCategorie = 0;
  $scope.selectedImage = null;

  $scope.getBackgroundImages = () => {
    $scope.backgroundImages = BackgroundImages.get(() => {
      $scope.isDialogLoading = false;

      $scope.selectCategory(0);
    });
  };

  $scope.hide = () => {
    $mdDialog.hide();
  };

  $scope.cancel = () => {
    $mdDialog.cancel();
  };

  $scope.select = image => {
    $mdDialog.hide(image);
  };

  $scope.selectCategory = id => {
    $scope.selectedCategorie = id;

    $scope.currentBackgroundImages = $scope.backgroundImages.categories.filter(item => {
      return item.id === id;
    })[0].images;
  };

  $scope.selectImage = image => {
    $scope.selectedImage = image;
  };

  // Init dialog
  $scope.getBackgroundImages();
}

export default class BackgroundController {
  $state
  $scope
  $rootScope
  $mdDialog
  canvas
  ngUpload
  backgroundImages
  backgroundImage

  /*@ngInject*/
  constructor($state, $scope, $rootScope, Canvas, Upload, $mdDialog, BackgroundImages) {
    this.$state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$mdDialog = $mdDialog;
    this.canvas = Canvas;
    this.ngUpload = Upload;
    this.backgroundImages = BackgroundImages;
  }

  $onInit = () => {
    this.$scope.zoom = [{ type: 'none', name: 'kein Zoom' }, { type: 'cover', name: 'Coverbild' }, { type: 'contain', name: 'Coverbild (innen)' }];

    this.$scope.bindingModel = this.canvas.getStageConfig();
    this.$scope.hasBackgroundImage = this.$scope.bindingModel.backgroundImage !== null;
    this.$scope.backgroundColorModel = {};
    this.$scope.backgroundImage = {
      zoom: 'cover'
    };

    this.canvas.stageInitialized(stage => {
      let config = this.canvas.getStageConfig();
      this.$scope.backgroundImage.zoom = config.backgroundImageScale;
    });
  }

  onBackgroundColorChanged = (hsb, hex, rgb) => {
    this.canvas.setBackgroundColor('#' + hex);
  }

  removeBackgroundImage = () => {
    this.canvas.setBackgroundImage(null);
    this.$scope.hasBackgroundImage = false;
  }

  onBackgroundZoomChanged = () => {
    this.$rootScope.log('Background zoom changed to: ' + this.$scope.backgroundImage.zoom);
    this.canvas.setBackgroundImageZoom(this.$scope.backgroundImage.zoom);
  }

  rotateLeft = () => {
    this.canvas.setBackgroundImageRotation(-90);
  }

  rotateRight = () => {
    this.canvas.setBackgroundImageRotation(90);
  }

  setGalleryImage = fileName => {
    let path = '/assets/images/background-images/' + fileName;
    this.canvas.setBackgroundImage(path);
    this.$scope.hasBackgroundImage = true;
  }

  selectImageFromGallery = ev => {
    this.$mdDialog
      .show({
        controller: GalleryDialogController,
        template: require('./background.gallery.dialog.html'),
        parent: $(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: false
      })
      .then(
        image => {
          // Image selected
          this.setGalleryImage(image);
        },
        () => {
          // Cancelled
        }
      );
  }

  upload = (file, invalidFiles) => {
    if(invalidFiles.length > 0) {
      this.$rootScope.fileUploadRejected();
      return;
    }

    if(file == null) {
      return;
    }

    try {
      let reader = new FileReader();
      reader.onload = (() => {
        return e => {
          let imageSource = e.target.result;
          this.canvas.setBackgroundImage(imageSource);
        };
      })(file);

      reader.readAsDataURL(file);
      this.$scope.hasBackgroundImage = true;
    } catch(e) {
      this.$rootScope.log(e);
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/configurator/background/background.controller.js